
export default {
  middleware: 'authOnly',
}
